import { useField, useFormikContext } from 'formik';

export const useCheckFormikError = ({
  name,
}: {
  name: string;
}): { error: string | null | object } => {
  // useField should be enough but it's not. There is a bug with the formik zod adapter
  // where the error isn't added to the array. This is a workaround.
  const meta = useField(name)[1];
  const { errors } = useFormikContext<{ [key: string]: string }>();
  if (!name || !meta.touched) {
    return { error: null };
  }

  if (meta.error) {
    return { error: meta.error };
  }

  if (errors[name]) {
    return { error: errors[name] };
  }

  // this is an even more annoying bug, the name of the error is formatted correctly when it's
  // first item in the array, see https://github.com/robertLichtnow/zod-formik-adapter/pull/24/files
  const strippedName = name.replace('.0', '');
  if (errors[strippedName]) {
    return { error: errors[strippedName] };
  }

  return { error: null };
};
